var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.854,
    height: 88.551,
    viewBox: "0 0 91.854 88.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5929",
    "data-name": "Group 5929",
    transform: "translate(-1551.012 -911.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_67_41",
    "data-name": "Component 67 \\u2013 41",
    transform: "translate(1551.012 911.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_179",
    "data-name": "Polygon 179",
    d: "M47.694,0A9,9,0,0,1,55.5,4.524L67.978,26.284a9,9,0,0,1,0,8.953L55.5,57a9,9,0,0,1-7.808,4.524H22.85A9,9,0,0,1,15.043,57L2.567,35.237a9,9,0,0,1,0-8.953L15.043,4.524A9,9,0,0,1,22.85,0Z",
    transform: "translate(0 35.272) rotate(-30)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(1587.047 977.743)",
    fill: "#3b3b3b",
    fontSize: 57,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.83e70578bd88d7008797992230842544.svg";
export { ForwardRef as ReactComponent };